<style scoped>
html {
  font-family: "Inter", sans-serif;
}
.fixed {
  overflow-y: scroll;
  height: 100vh;
  position: fixed;
  width: 24.5%;
  overflow-y: scroll;
  background-color: white;
  z-index: 999;
  padding-bottom: 5rem;
}

.mt-100 {
  margin-top: 100px;
}

.modal {
  background-image: linear-gradient(
    rgb(35, 79, 71) 0%,
    rgb(36, 121, 106) 100.2%
  );
}

.modal-title {
  font-weight: 900;
}

.modal-content {
  border-radius: 13px;
}

.modal-body {
  color: #3b3b3b;
}

.img-thumbnail {
  border-radius: 33px;
  width: 61px;
  height: 61px;
}

.fa:before {
  position: relative;
  top: 13px;
}

.smd {
  width: 200px;
  font-size: small;
  text-align: center;
}

.modal-footer {
  display: block;
}

.ur {
  border: none;
  background-color: #e6e2e2;
  border-bottom-left-radius: 4px;
  border-top-left-radius: 4px;
}

.cpy {
  border: none;
  background-color: #e6e2e2;
  border-bottom-right-radius: 4px;
  border-top-right-radius: 4px;
  cursor: pointer;
}

button.focus,
button:focus {
  outline: 0;
  box-shadow: none !important;
}

.ur.focus,
.ur:focus {
  outline: 0;
  box-shadow: none !important;
}

.message {
  font-size: 10px;
  color: #ee5535;
}

.loader {
  text-align: center;
}
.breadcrumb-item a {
  color: rgb(0 147 221) !important;
}
.breadcrumb-item {
  font-size: 1rem;
  font-weight: 600;
}
.breadcrumb {
  display: flex;
  box-shadow: none;
  border: none;
}
.topic-button:hover {
  color: white;
  background-color: rgb(193, 193, 193) !important;
}

.topic-button.active {
  color: white;
  background-color: rgb(0 43 106) !important;
}

.topic-button {
  font-weight: lighter;
  text-align: left;
  width: 100%;
  color: grey;
  font-weight: 800 !important;
  border-radius: 10px !important;
}
.katalog >>> li > button {
  color: rgb(0 43 106);
}

.katalog >>> li.active > button {
  color: white !important;
  background-color: rgb(0 43 106) !important;
}
.katalog >>> li > button:hover {
  color: white;
  background-color: rgb(0 43 106) !important;
}
</style>
<template>
  <b-container
    fluid
    class="main-wrapper"
    style="
      color: black;
      padding-bottom: 5%;
      font-family: 'Inter', 'sans-serif' !important;
    "
  >
    <b-row class="ml-5 mr-5 mt-5 mb-0">
      <b-col class="ml-5 mr-5">
        <b-breadcrumb :items="breadcrumbs" class="breadcrumbs"></b-breadcrumb>
        <h2 class="mt-4">Katalog Data</h2>
      </b-col></b-row
    >
    <b-row
      class="ml-5 mr-5 mb-0"
      style="padding-left: 3.5em; padding-right: 3.5em"
    >
      <b-col cols="4">
        <b-card class="mb-2" style="border-radius: 20px; padding: 0px">
          <b-button
            @click="doFilterCategory(item, $event)"
            v-for="item in topik"
            :key="item"
            class="topic-button"
            >{{ item }}</b-button
          >
        </b-card></b-col
      ><b-col cols="8">
        <b-card
          style="
            box-shadow: none;
            border: 1px solid #f1f3f4 !important;
            border-radius: 20px;
            min-height: 100vh;
          "
        >
          <div>
            <b-input-group size="sm" prepend>
              <b-form-input
                v-model="search"
                style="box-shadow: none"
                @keyup.enter="cari"
              ></b-form-input>
              <b-input-group-append>
                <b-button
                  @click="cari()"
                  style="
                    box-shadow: none !important;
                    border: 1px solid rgb(0 43 106) !important;
                    background-color: rgb(0 43 106) !important;
                  "
                  variant="primary"
                  >Cari</b-button
                >
              </b-input-group-append>
            </b-input-group>
          </div>
          <div style="min-height: 100vh; padding: 5px 0">
            <div v-if="isLoading">
              <b-card class="my-3">
                <b-skeleton animation="wave" width="85%"></b-skeleton>
                <b-skeleton animation="wave" width="55%"></b-skeleton>
                <b-skeleton animation="wave" width="70%"></b-skeleton>
              </b-card>
              <b-card class="my-3">
                <b-skeleton animation="wave" width="85%"></b-skeleton>
                <b-skeleton animation="wave" width="55%"></b-skeleton>
                <b-skeleton animation="wave" width="70%"></b-skeleton>
              </b-card>
              <b-card class="my-3">
                <b-skeleton animation="wave" width="85%"></b-skeleton>
                <b-skeleton animation="wave" width="55%"></b-skeleton>
                <b-skeleton animation="wave" width="70%"></b-skeleton>
              </b-card>
              <b-card class="my-3">
                <b-skeleton animation="wave" width="85%"></b-skeleton>
                <b-skeleton animation="wave" width="55%"></b-skeleton>
                <b-skeleton animation="wave" width="70%"></b-skeleton>
              </b-card>
              <b-card class="my-3">
                <b-skeleton animation="wave" width="85%"></b-skeleton>
                <b-skeleton animation="wave" width="55%"></b-skeleton>
                <b-skeleton animation="wave" width="70%"></b-skeleton>
              </b-card>
              <b-card class="my-3">
                <b-skeleton animation="wave" width="85%"></b-skeleton>
                <b-skeleton animation="wave" width="55%"></b-skeleton>
                <b-skeleton animation="wave" width="70%"></b-skeleton>
              </b-card>
            </div>
            <div v-else>
              <div class="mt-1" v-if="dataToShow.length > 0">
                <span style="font-size: 0.75rem; position: absolute">
                  Menampilkan {{ (currentPage - 1) * 10 + 1 }} -
                  {{
                    currentPage * 10 > totalRow ? totalRow : currentPage * 10
                  }}
                  dari {{ totalRow }} Data
                </span>
                <b-pagination
                  align="right"
                  size="sm"
                  v-model="currentPage"
                  :per-page="perPage"
                  :total-rows="totalRow"
                  @page-click="changePage"
                  class="katalog"
                ></b-pagination>
              </div>
              <div class="mt-1" v-else>
                <span style="font-size: 0.75rem"> Data Tidak Ditemukan </span>
              </div>

              <b-card
                v-for="item in dataToShow"
                :key="item.id"
                style="
                  width: 100%;
                  margin: 1rem 0;
                  border: 1px solid #cccccc !important;
                  box-shadow: none;
                  border-radius: 20px;
                "
              >
                <div
                  class="float-right"
                  style="font-size: 0.75rem; text-transform: capitalize"
                >
                  <span v-if="item.type == 'Data Agregat'"
                    ><b-icon icon="bar-chart-fill"></b-icon
                    >{{ item.type }}</span
                  >
                  <span
                    v-else
                    style="font-size: 0.75rem; text-transform: capitalize"
                    ><b-icon icon="table"></b-icon>{{ item.type }}</span
                  >
                </div>
                <span style="font-size: 0.75rem; text-transform: capitalize">{{
                  item.subject_field.toString()
                }}</span>
                <p
                  class="data-title"
                  style="cursor: pointer; font-weight: 600; margin-bottom: 0px"
                >
                  <b-link
                    v-if="item.type == 'Mikrodata'"
                    :to="'data/data-view/micro/' + item.id"
                    style="color: rgb(0 43 106) !important"
                    >{{ item.name }}</b-link
                  >
                  <b-link
                    v-else
                    :to="'data/data-view/' + item.id"
                    style="color: rgb(0 43 106) !important"
                    >{{ item.name }}</b-link
                  >
                </p>
                <span style="font-size: 0.75rem; text-transform: capitalize"
                  >Pemilik Data: {{ item.owner }} | Pengelola:
                  {{ item.maintainer == null ? "---" : item.maintainer }} |
                  Frekuensi: {{ item.frequency }}</span
                >
              </b-card>
            </div>
          </div>
          <b-pagination
            align="right"
            size="sm"
            v-model="currentPage"
            :per-page="perPage"
            :total-rows="totalRow"
            @page-click="changePage"
            class="katalog"
          ></b-pagination>
        </b-card> </b-col
    ></b-row>
  </b-container>
</template>
<style scoped>
</style>
<script>
import mmsService from "../../services/MmsService";
// import vSelect from "vue-select";
// import "vue-select/dist/vue-select.css";
export default {
  name: "Data",
  props: {
    projectName: {
      type: String,
      required: false,
    },
  },
  data: () => {
    return {
      topik: ["Capaian AKPSH", "Kelahiran", "Kematian", "Kesehatan"],
      breadcrumbs: [
        {
          text: "Beranda",
          to: "/sshi",
        },
        {
          text: "Katalog Data",
          active: true,
        },
      ],
      dataToShow: [],
      observer: null,
      subjectTes: [],
      subjectTesOptions: [],
      isLoading: true,
      data: [],
      filteredData: [],
      currentPage: 1,
      totalPages: "",
      perPage: 10,
      totalRow: "",
      wilayahSelected: null,
      wilayahOptions: [{ value: null, text: "Pilih Wilayah" }],
      jenisDataSelected: null,
      jenisDataOptions: [],
      frekuensiSelected: null,
      frekuensiOptions: [],
      subjectSelected: null,
      subjectOptions: [{ value: null, text: "Pilih Subyek" }],
      organisasiSelected: null,
      organisasiOptions: [{ value: null, text: "Pilih Organisasi" }],
      divisiSelected: null,
      divisiOptions: [{ value: null, text: "Pilih Divisi" }],
      kegiatanStatistikSelected: null,
      kegiatanStatistikOptions: [
        { value: null, text: "Pilih Kegiatan Statistik" },
      ],
      sumberDataSelected: [],
      sumberDataOptions: [
        { name: "Data Warehouse", id: "dwh" },
        { name: "Hadoop", id: "hadoop" },
      ],
      variabelSelected: null,
      variabelOptions: [],
      indikatorSelected: null,
      indikatorOptions: [{ value: null, text: "Pilih Indikator" }],
      klasifikasiSelected: null,
      klasifikasiOptions: [{ value: null, text: "Pilih Klasifikasi/Dimensi" }],
      periodeSelected: null,
      periodeOptions: [
        { value: null, text: "Pilih Periode" },
        { value: "2010", text: "2010" },
        { value: "2020", text: "2020" },
      ],
      levelKerahasiaanDataSelected: [],
      levelKerahasiaanDataOptions: [
        { text: "Public", value: "pubic" },
        { text: "Internal Use", value: "internal" },
        { text: "Restricted", value: "restricted" },
        { text: "Confidential", value: "confidential" },
      ],
      dataCategorySelected: null,
      dataCategoryOptions: [
        { value: null, text: "Relevansi" },
        { value: "tanggal", text: "Tanggal" },
        { value: "judul", text: "Judul" },
      ],
      filterCategory: [],
      selectedCategory: "",
      search: "",
    };
  },
  components: {
    // vSelect,
  },
  mounted() {
    // this.loadSubjectTes(0);
    this.selectedCategory = this.$route.query.kategori;
    if (this.$route.query.kategori !== undefined) {
      const buttons = document.querySelectorAll(".topic-button");
      buttons.forEach((button) => {
        // Jika tombol yang diklik adalah tombol saat ini, jadikan aktif
        if (
          button.textContent.toLowerCase() ===
          this.selectedCategory.toLowerCase()
        ) {
          button.classList.add("active");
        } else {
          button.classList.remove("active");
        }
      });
    }

    this.observer = new IntersectionObserver(this.infiniteScroll);
    this.loadData(null, 0);
  },
  created() {
    // this.loadJenisData("jenis data");
  },
  computed: {
    filtered() {
      return this.subjectTesOptions.filter((item) =>
        item.name.toLowerCase().includes(this.search.toLowerCase())
      );
      // return this.subjectTesOptions.filter((item) =>
      //   item.name.toLowerCase().includes(this.search.toLowerCase())
      // ).sort((a,b)=> (a.name > b.name ? 1 : -1));
    },
    paginated() {
      return this.subjectTesOptions;
    },
    hasNextPage() {
      return this.subjectTesOptions.length < this.subjectTes.totalElements;
    },
  },
  methods: {
    doFilterCategory(category, event) {
      this.search = "";
      if (event !== undefined) {
        const buttons = document.querySelectorAll(".topic-button");
        buttons.forEach((button) => {
          // Jika tombol yang diklik adalah tombol saat ini, jadikan aktif
          if (button === event.target) {
            button.classList.add("active");
            if (this.selectedCategory == category) {
              button.classList.remove("active");
              this.selectedCategory = "";
            } else {
              this.selectedCategory = category;
            }
          } else {
            button.classList.remove("active");
          }
        });
      }
      this.selectedCategory = category;
      if (this.selectedCategory !== "") {
        this.filteredData = this.data.filter(
          (item) => item.category.toLowerCase() === category.toLowerCase()
        );
        this.dataToShow = this.filteredData.slice(0, 10);
        this.totalRow = this.filteredData.length;
        this.currentPage = 1;
      } else {
        this.filteredData = this.data;
        this.dataToShow = this.filteredData.slice(0, 10);
        this.totalRow = this.filteredData.length;
        this.currentPage = 1;
      }
    },
    async loadData(filter, page) {
      await mmsService.getDataProject(filter, this.projectName, page).then(
        (response) => {
          let data = response.data.result[0].content.map((item) => {
            return { ...item, subject_field: item.subjectField }; // Menambahkan variabel baru tanpa menghapus yang lama
          });
          this.isLoading = false;
          this.data = data;
          this.currentPage = page + 1;
          this.totalRow = response.data.result[0].total_elements;
          this.totalPages = response.total_pages;
          this.dataToShow = this.data.slice(0, this.perPage);
          this.filteredData = this.data;
          this.doFilterCategory(this.selectedCategory);
        },
        (error) => {
          this.loadData(filter, page, this.projectName);
          this.data =
            (error.response && error.response.data) ||
            error.message ||
            error.toString();
        }
      );
    },
    async loadJenisData(query) {
      await mmsService.getControlledVocabullaryItem(query).then(
        (response) => {
          this.jenisDataOptions = response.data.result;
          this.loadFrekuensi("frekuensi");
        },
        (error) => {
          this.loadJenisData(query);
          this.data =
            (error.response && error.response.data) ||
            error.message ||
            error.toString();
        }
      );
    },
    async loadFrekuensi(query) {
      await mmsService.getControlledVocabullaryItem(query).then(
        (response) => {
          this.frekuensiOptions = response.data.result;
          this.loadSubyek();
        },
        (error) => {
          this.data =
            (error.response && error.response.data) ||
            error.message ||
            error.toString();
        }
      );
    },
    async loadSubyek() {
      await mmsService.getObjectSlug("subject-field", 0).then(
        (response) => {
          this.subjectOptions = response.data.result[0].data.content;
          this.loadOrganisasi();
        },
        (error) => {
          this.data =
            (error.response && error.response.data) ||
            error.message ||
            error.toString();
        }
      );
    },
    capitalize(str) {
      const arr = str.split(" ");
      for (var i = 0; i < arr.length; i++) {
        arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1);
      }
      const str2 = arr.join(" ");
      return str2;
    },
    async loadSubjectTes(page) {
      await mmsService.getObjectSlug("subject-field", page).then(
        (response) => {
          this.isLoading = false;
          this.subjectTes = response.data.result[0].data;
          let i = 0;
          for (i; i < this.subjectTes.content.length; i++) {
            this.subjectTesOptions.push({
              id: this.subjectTes.content[i].id,
              name: this.capitalize(this.subjectTes.content[i].name),
            });
          }
        },
        (error) => {
          this.data =
            (error.response && error.response.data) ||
            error.message ||
            error.toString();
        }
      );
    },
    async loadOrganisasi() {
      await mmsService.getObjectSlug("organization", 0).then(
        (response) => {
          this.organisasiOptions = response.data.result[0].data.content;
          this.loadDivisi();
        },
        (error) => {
          this.data =
            (error.response && error.response.data) ||
            error.message ||
            error.toString();
        }
      );
    },
    async loadDivisi() {
      await mmsService.getObjectSlug("division", 0).then(
        (response) => {
          this.divisiOptions = response.data.result[0].data.content;
          this.loadKegiatanStatistik();
        },
        (error) => {
          this.data =
            (error.response && error.response.data) ||
            error.message ||
            error.toString();
        }
      );
    },
    async loadKegiatanStatistik() {
      await mmsService.getObjectSlug("statistical-program-cycle", 0).then(
        (response) => {
          this.kegiatanStatistikOptions = response.data.result[0].data.content;
          this.loadVariabel();
        },
        (error) => {
          this.data =
            (error.response && error.response.data) ||
            error.message ||
            error.toString();
        }
      );
    },
    async loadSumberData() {
      await mmsService.getControlledVocabullaryItem("sumber data").then(
        (response) => {
          this.sumberDataOptions = response.data.result;
        },
        (error) => {
          this.data =
            (error.response && error.response.data) ||
            error.message ||
            error.toString();
        }
      );
    },
    async loadVariabel() {
      await mmsService.getObjectSlug("variable", 0).then(
        (response) => {
          this.variabelOptions = response.data.result[0].data.content;
          this.loadIndikator();
        },
        (error) => {
          this.data =
            (error.response && error.response.data) ||
            error.message ||
            error.toString();
        }
      );
    },
    async loadIndikator() {
      await mmsService.getObjectSlug("statistical-indicator", 0).then(
        (response) => {
          this.indikatorOptions = response.data.result[0].data.content;
          this.loadKlasifikasi();
        },
        (error) => {
          this.data =
            (error.response && error.response.data) ||
            error.message ||
            error.toString();
        }
      );
    },
    async loadKlasifikasi() {
      await mmsService.getObjectSlug("classification-series", 0).then(
        (response) => {
          this.klasifikasiOptions = response.data.result[0].data.content;
        },
        (error) => {
          this.data =
            (error.response && error.response.data) ||
            error.message ||
            error.toString();
        }
      );
    },
    changePage(event, page) {
      if (event) {
        const startIndex = (page - 1) * this.perPage;
        const endIndex = startIndex + this.perPage;
        this.dataToShow = this.filteredData.slice(startIndex, endIndex);
      }
    },
    reset() {
      this.loadData(null, 0);
      this.search = null;
      this.jenisDataSelected = null;
    },
    share() {
      this.$refs["share-modal"].show();
    },
    setFilterCategory(array, predicate) {
      let end = 0;

      for (let i = 0; i < array.length; i++) {
        const obj = array[i];

        if (predicate(obj)) {
          array[end++] = obj;
        }
      }

      array.length = end;
    },
    cari() {
      if (this.search === "") {
        if (this.selectedCategory !== "") {
          this.filteredData = this.data.filter(
            (item) => item.category === this.selectedCategory
          );
          this.dataToShow = this.filteredData.slice(0, 10);
          this.totalRow = this.filteredData.length;
          this.currentPage = 1;
        } else {
          this.filteredData = this.data;
          this.dataToShow = this.filteredData.slice(0, 10);
          this.totalRow = this.filteredData.length;
          this.currentPage = 1;
        }
      } else {
        const keywords = this.search.toLowerCase().split(" "); // Pisahkan kata-kata
        if (this.category !== "") {
          this.filteredData = this.filteredData.filter((item) =>
            keywords.every((keyword) =>
              item.name.toLowerCase().includes(keyword)
            )
          );
        } else {
          this.filteredData = this.data.filter((item) =>
            keywords.every((keyword) =>
              item.name.toLowerCase().includes(keyword)
            )
          );
        }

        this.dataToShow = this.filteredData.slice(0, 10);
        this.totalRow = this.filteredData.length;
        this.currentPage = 1;
      }

      // let filterData = "";
      // if (this.filterCategory.length > 0) {
      //   for (let i = 0; i < this.filterCategory.length; i++) {
      //     if (i == this.filterCategory.length - 1) {
      //       filterData =
      //         filterData +
      //         this.filterCategory[i].id +
      //         "$" +
      //         this.filterCategory[i].value;
      //     } else {
      //       filterData =
      //         filterData +
      //         this.filterCategory[i].id +
      //         "$" +
      //         this.filterCategory[i].value +
      //         "&";
      //     }
      //   }
      // }
      // this.loadData(
      //   filterData == ""
      //     ? "name$" + this.search
      //     : filterData + "&name$" + this.search,
      //   0
      // );
    },
    async onOpen() {
      if (this.hasNextPage) {
        await this.$nextTick();
        this.observer.observe(this.$refs.load);
      }
    },
    onClose() {
      this.observer.disconnect();
    },
    async infiniteScroll([{ isIntersecting, target }]) {
      if (isIntersecting) {
        const ul = target.offsetParent;
        const scrollTop = target.offsetParent.scrollTop;
        this.loadSubjectTes(this.subjectTes.number + 1);
        await this.$nextTick();
        ul.scrollTop = scrollTop;
      }
    },
  },
  watch: {
    filterCategory(val) {
      let filterData = "";
      if (val.length > 0) {
        for (let i = 0; i < val.length; i++) {
          if (i == val.length - 1) {
            filterData = filterData + val[i].id + "$" + val[i].value;
          } else {
            filterData = filterData + val[i].id + "$" + val[i].value + "&";
          }
        }
        this.loadData(filterData, 0);
      }
    },
    jenisDataSelected(val) {
      if (val) {
        let toDelete = new Set(["typeId"]);
        this.setFilterCategory(
          this.filterCategory,
          (obj) => !toDelete.has(obj.id)
        );
        this.filterCategory.push({ id: "typeId", value: val });
      } else {
        let toDelete = new Set(["typeId"]);
        this.setFilterCategory(
          this.filterCategory,
          (obj) => !toDelete.has(obj.id)
        );
        if (this.filterCategory.length < 1) {
          this.loadData(null, 0);
        }
      }
    },
    frekuensiSelected(val) {
      if (val != "null") {
        let toDelete = new Set(["frequency"]);
        this.setFilterCategory(
          this.filterCategory,
          (obj) => !toDelete.has(obj.id)
        );
        this.filterCategory.push({ id: "frequency", value: val });
      } else {
        let toDelete = new Set(["frequency"]);
        this.setFilterCategory(
          this.filterCategory,
          (obj) => !toDelete.has(obj.id)
        );
        if (this.filterCategory.length < 1) {
          this.loadData(null, 0);
        }
      }
    },
    subjectSelected(val) {
      if (val != "null") {
        let toDelete = new Set(["subjectFieldId"]);
        this.setFilterCategory(
          this.filterCategory,
          (obj) => !toDelete.has(obj.id)
        );
        this.filterCategory.push({ id: "subjectFieldId", value: val.id });
      } else {
        let toDelete = new Set(["subjectFieldId"]);
        this.setFilterCategory(
          this.filterCategory,
          (obj) => !toDelete.has(obj.id)
        );
        if (this.filterCategory.length < 1) {
          this.loadData(null, 0);
        }
      }
    },
    organisasiSelected(val) {
      if (val != "null") {
        let toDelete = new Set(["ownerId"]);
        this.setFilterCategory(
          this.filterCategory,
          (obj) => !toDelete.has(obj.id)
        );
        this.filterCategory.push({ id: "ownerId", value: val });
      } else {
        let toDelete = new Set(["ownerId"]);
        this.setFilterCategory(
          this.filterCategory,
          (obj) => !toDelete.has(obj.id)
        );
        if (this.filterCategory.length < 1) {
          this.loadData(null, 0);
        }
      }
    },
    divisiSelected(val) {
      if (val != "null") {
        let toDelete = new Set(["maintainerId"]);
        this.setFilterCategory(
          this.filterCategory,
          (obj) => !toDelete.has(obj.id)
        );
        this.filterCategory.push({ id: "maintainerId", value: val });
      } else {
        let toDelete = new Set(["maintainerId"]);
        this.setFilterCategory(
          this.filterCategory,
          (obj) => !toDelete.has(obj.id)
        );
        if (this.filterCategory.length < 1) {
          this.loadData(null, 0);
        }
      }
    },
    kegiatanStatistikSelected(val) {
      if (val != "null") {
        let toDelete = new Set(["statisticalProgramCycleId"]);
        this.setFilterCategory(
          this.filterCategory,
          (obj) => !toDelete.has(obj.id)
        );
        this.filterCategory.push({
          id: "statisticalProgramCycleId",
          value: val,
        });
      } else {
        let toDelete = new Set(["statisticalProgramCycleId"]);
        this.setFilterCategory(
          this.filterCategory,
          (obj) => !toDelete.has(obj.id)
        );
        if (this.filterCategory.length < 1) {
          this.loadData(null, 0);
        }
      }
    },
    sumberDataSelected(val) {
      if (val != "null") {
        let toDelete = new Set(["databaseId"]);
        this.setFilterCategory(
          this.filterCategory,
          (obj) => !toDelete.has(obj.id)
        );
        this.filterCategory.push({
          id: "databaseId",
          value: val,
        });
      } else {
        let toDelete = new Set(["databaseId"]);
        this.setFilterCategory(
          this.filterCategory,
          (obj) => !toDelete.has(obj.id)
        );
        if (this.filterCategory.length < 1) {
          this.loadData(null, 0);
        }
      }
    },
    variabelSelected(val) {
      if (val != "null") {
        let toDelete = new Set(["variableId"]);
        this.setFilterCategory(
          this.filterCategory,
          (obj) => !toDelete.has(obj.id)
        );
        this.filterCategory.push({
          id: "variableId",
          value: val,
        });
      } else {
        let toDelete = new Set(["variableId"]);
        this.setFilterCategory(
          this.filterCategory,
          (obj) => !toDelete.has(obj.id)
        );
        if (this.filterCategory.length < 1) {
          this.loadData(null, 0);
        }
      }
    },
    indikatorSelected(val) {
      if (val != "null") {
        let toDelete = new Set(["statisticalIndicatorId"]);
        this.setFilterCategory(
          this.filterCategory,
          (obj) => !toDelete.has(obj.id)
        );
        this.filterCategory.push({
          id: "statisticalIndicatorId",
          value: val,
        });
      } else {
        let toDelete = new Set(["statisticalIndicatorId"]);
        this.setFilterCategory(
          this.filterCategory,
          (obj) => !toDelete.has(obj.id)
        );
        if (this.filterCategory.length < 1) {
          this.loadData(null, 0);
        }
      }
    },
    klasifikasiSelected(val) {
      if (val != "null") {
        let toDelete = new Set(["classificationSeriesId"]);
        this.setFilterCategory(
          this.filterCategory,
          (obj) => !toDelete.has(obj.id)
        );
        this.filterCategory.push({
          id: "classificationSeriesId",
          value: val,
        });
      } else {
        let toDelete = new Set(["classificationSeriesId"]);
        this.setFilterCategory(
          this.filterCategory,
          (obj) => !toDelete.has(obj.id)
        );
        if (this.filterCategory.length < 1) {
          this.loadData(null, 0);
        }
      }
    },
  },
};
</script>
